import Controller from "./packages.controller";
import template from "./packages.html";

const packages = {
  template,
  controller: Controller,
};

export default packages;



// WEBPACK FOOTER //
// ./src/pages/packages/packages.component.js